var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4074 1.85444C17.5674 1.6508 17.5965 1.38899 17.4801 1.15626C17.3637 0.923531 17.1456 0.778076 16.8837 0.778076H1.10192C0.854646 0.778076 0.621918 0.923531 0.505555 1.15626C0.389191 1.38899 0.432827 1.6508 0.578282 1.85444L8.33101 11.5417V17.8835H5.71283C5.34919 17.8835 5.05828 18.1744 5.05828 18.5381C5.05828 18.9017 5.34919 19.1926 5.71283 19.1926H12.2874C12.651 19.1926 12.9419 18.9017 12.9419 18.5381C12.9419 18.1744 12.651 17.8835 12.2874 17.8835H9.65465V11.5417L17.4074 1.85444ZM3.53101 3.42535L2.48374 2.11626H15.531L14.4837 3.42535H3.53101Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarIcon);
export default __webpack_public_path__ + "static/media/bar_icon.8f1bc441a2715b96ed3a748653f68a17.svg";
export { ForwardRef as ReactComponent };